import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton.tsx';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton.tsx';
import config from '../config';

const useTools = () => {

    const {allowedActions} = useVerifiedPermissions();

    // APPEND-ONLY module: no Add and NO EDIT, ever — the executor owns creation and
    // an observation must not be rewritable. FNP-969 adds Delete only, gated on its
    // own id.
    const tools = [
        <FilterRecordsButton key='filter'/>,
        <ReloadRecordsButton key='reload'/>,
    ];

    if (allowedActions.includes(rbacActions.DeleteTestObservation)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
